import { motion } from 'framer-motion'
import { ShieldCheck, ArrowLeft, KeyRound } from 'lucide-react'
import type { LoginStepFormProps } from '@/components/Login/loginTypes'
import { LoginAlerts } from '@/components/Login/LoginAlerts'

export function LoginTwoFactorForm({ flow, theme, brandColor }: LoginStepFormProps) {
  return (
    <motion.form
      key="twoFactor"
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 20 }}
      transition={{ duration: 0.3 }}
      onSubmit={flow.handleTwoFactorSubmit}
      className="login-form"
      style={{ display: 'flex', flexDirection: 'column', gap: 20 }}
    >
      <div className="login-field" style={{ textAlign: 'center' }}>
        <ShieldCheck size={48} style={{ color: brandColor, margin: '0 auto 16px auto', display: 'block' }} />
        <p style={{ color: theme.fontColorMuted || '#8a8a95', fontSize: '0.875rem', lineHeight: 1.6 }}>
          Enviamos um código de 10 caracteres (letras e números) para o e-mail<br />
          <strong style={{ color: theme.textPrimary || '#f5f5f6' }}>{flow.email}</strong>
        </p>
      </div>

      <LoginAlerts flow={flow} showSuccess={false} />

      <div className="login-field">
        <label htmlFor="twoFactorCode" style={{ textAlign: 'center' }}>
          Código de Verificação
        </label>
        <div className="login-input-wrapper" style={{ position: 'relative' }}>
          <KeyRound size={16} style={{ position: 'absolute', left: 14, color: theme.textMuted || '#8a8a95', zIndex: 1 }} />
          <input
            id="twoFactorCode"
            name="one-time-code"
            type="text"
            inputMode="text"
            autoComplete="one-time-code"
            placeholder="K7R4M2NPQR"
            value={flow.twoFactorCode}
            onChange={(e) => flow.setTwoFactorCode(e.target.value.toUpperCase().replace(/[^A-Z2-9]/g, '').substring(0, 10))}
            required
            autoFocus
            spellCheck={false}
            style={{ textAlign: 'center', letterSpacing: 4, fontWeight: 'bold' }}
          />
        </div>
      </div>

      <button
        type="submit"
        className="login-submit"
        disabled={flow.isAnyPending || flow.twoFactorCode.length !== 10}
        style={{
          background: brandColor,
          boxShadow: `0 4px 15px ${brandColor}4D`,
          opacity: flow.isAnyPending || flow.twoFactorCode.length !== 10 ? 0.5 : 1,
        }}
      >
        {flow.isAnyPending ? <span className="login-spinner" /> : <><ShieldCheck size={18} /> Verificar Acesso</>}
      </button>

      <button type="button" onClick={flow.goBack} className="login-back-btn">
        <ArrowLeft size={14} /> Voltar ao Login
      </button>
    </motion.form>
  )
}
